"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tv4 = require('tv4');
var ORGANIZATION_TYPES = require('../../constant/organization/organization-type.constant');
var Organization = /*#__PURE__*/function () {
  function Organization(opt) {
    _classCallCheck(this, Organization);
    this._id = null;
    this.campusCode = null;
    this.code = null;
    this.data = {};
    this.isActive = true;
    this.lastModifiedDate = null;
    this.name = null;
    this.type = null;
    if (opt) {
      this.fillObject(opt);
    }
  }
  _createClass(Organization, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = opt._id;
      this.campusCode = opt.campusCode;
      this.code = opt.code;
      this.data = opt.data;
      this.isActive = opt.isActive || true;
      this.lastModifiedDate = opt.lastModifiedDate ? new Date(opt.lastModifiedDate) : null;
      this.name = opt.name;
      this.type = opt.type;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Organization.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'organization.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'string'
          },
          campusCode: {
            type: 'string'
          },
          code: {
            type: 'string'
          },
          data: {
            type: 'object'
          },
          isActive: {
            type: 'boolean'
          },
          lastModifiedDate: {
            type: 'object'
          },
          name: {
            type: 'string'
          },
          type: {
            "enum": Object.keys(ORGANIZATION_TYPES)
          }
        },
        required: Object.keys(new Organization())
      };
    }
  }]);
  return Organization;
}();
module.exports = Organization;